(function () {
    'use strict';

    a3_cabin_reports.directive('flightServiceEvents', flightServiceEvents);
    /**
    * @memberof CabinReports
    * @ngdoc directive
    * @name flightServiceEvents
    * @restrict E
    * @description
    *   Implementation of flightServiceEvents panel
    * @example
    *   Usage:
    *   <flight-service-events></flight-service-events>
    * @ngInject
    */
    function flightServiceEvents(FlightServiceEventsFactory, $sce, $uibModal) {
        function link(scope,  element, attributes) {
            //scope.save = save;
            scope.events = [];
            scope.eventTypes = [];
            scope.openEvent = openEvent;
            scope.isRefreshing = false;
            scope.refreshEvents = refreshEvents;
            
            //get from LS the events & the types
            getEventsNTypes(scope.flightId);
  
            function getEventsNTypes(flightId){
                scope.showPanel = null;
                scope.eventTypes = FlightServiceEventsFactory.getEventTypes();
                scope.events = FlightServiceEventsFactory.getEventsByFlightIdFromLS(flightId);
                //Merge eventTypes and events using common Code property
                scope.eventTypes.forEach(type => {
                    var eventInType = scope.events.filter(x=>x.EventCode == type.Code);
                    if(eventInType[0]){
                        type.event = eventInType[0];
                    }
                    else{
                        type.event =
                        {
                            FlightId: flightId,
                            EventTypeId: type.Id,
                            EventCode: type.Code,
                            StartTime: null,
                            EndTime: null,
                            NotRequired: null,
                            Remarks: null
                        };
                    }
                });
            }

            function refreshEvents(){
                scope.isRefreshing = true;
                if(scope.isOffline){
                    scope.showPanel = "offline";
                    scope.isRefreshing = false;
                }
                else{
                    FlightServiceEventsFactory.getEvents(scope.flightId)
                        .then(res => handleRefreshResponse(res));
                }

            }
        
            function handleRefreshResponse(results){
                if(results && results.data && results.data.success && results.data.data && results.data.data.length>0){
                    FlightServiceEventsFactory.setEventsForFlightId(scope.flightId, results.data.data);
                    getEventsNTypes(scope.flightId);
                }
                scope.isRefreshing = false;
            }

            /**
            * Open modal to see information for the selected Memo
            * @memberof memosByCategory
            * @param {object} eventType with event object
            */
            function openEvent(eventType) {
                var modalInstance = $uibModal.open({
                    templateUrl: 'views/FlightServiceEvents/dlgEventForm.html',
                    controller: 'EventFormModalCtrl',
                    backdrop: 'static',
                    keyboard: false,
                    size: 'md',
                    resolve: {
                        eventType: function () {
                            return eventType;
                        }
                    }
                });
 
                modalInstance.result.then(function () {
                    //dismiss event
                    refreshEvents();
                }, function () {
                    //close event
                    refreshEvents();
                    
				});


              
            }

        }

        return {
            restrict: 'E',
            terminal: false,
            templateUrl: 'views/FlightServiceEvents/flightServiceEvents.tpl.html',
            scope: false,
            link: link
        }
    }

})();
